import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import BackButton from '@/components/BackButton.vue';
const blobsModule = namespace('blobs');
let VariantRulesDetail = class VariantRulesDetail extends Vue {
    created() {
        this.fetchVariantRuleBlobs();
    }
    get title() {
        return this.variantRuleName + Vue.prototype.$titleSuffix;
    }
    get blob() {
        return this.variantRuleBlobs.find(({ chapterName }) => chapterName === this.variantRuleName);
    }
};
__decorate([
    blobsModule.State
], VariantRulesDetail.prototype, "variantRuleBlobs", void 0);
__decorate([
    blobsModule.Action
], VariantRulesDetail.prototype, "fetchVariantRuleBlobs", void 0);
__decorate([
    Prop(String)
], VariantRulesDetail.prototype, "variantRuleName", void 0);
VariantRulesDetail = __decorate([
    Component({
        components: {
            VueMarkdown,
            BackButton,
            Loading
        }
    })
], VariantRulesDetail);
export default VariantRulesDetail;
